import {LogoVk, LogoYoutube, PaperPlaneOutline, CallOutline} from "@chayka/icons";
import {Button, XStack, YStack} from "@chayka/ui";

export const ErrorBoundary = () => {
  return (
    <YStack className="items-center justify-center h-screen p-6 gap-6">
      <h1 className="text-3xl font-light">Что-то пошло не так</h1>
      <p className="text-gray-600 text-sm text-center">Пожалуйста, попробуйте обновить страницу.</p>
      <Button variant="secondary" className="self-stretch" onClick={() => window.location.reload()}>
        Обновить
      </Button>
      <XStack className="gap-4">
        <a href="https://vk.com/chayka_studia" target="_blank" rel="noopener noreferrer">
          <LogoVk size={30} />
        </a>
        <a
          href="https://www.youtube.com/channel/UCJTdTkr2ctU4q_uuIvXO3uQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LogoYoutube size={30} />
        </a>
        <a href="https://t.me/chaykastudia" target="_blank" rel="noopener noreferrer">
          <PaperPlaneOutline size={30} />
        </a>
        <a href="tel:+79919457575" target="_blank" rel="noopener noreferrer">
          <CallOutline size={30} />
        </a>
      </XStack>
    </YStack>
  );
};
